module.exports = __webpack_public_path__ + "media/images/official/voice_kadono-62d3b0549d877b9aa998f4547ac2dc6a.png";